var bz_app = angular.module(
  'bz_app',
  ['ui.bootstrap', 'angular-carousel', 'bzLocationModule'].concat(
    defaultAngularModuleSet
  )
)

angular.element(document).ready(function () {
  angular.bootstrap(document, ['bz_app'])
})

window.bz_app = bz_app
